import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueGeolocation from 'vue-browser-geolocation'

// Imported only by the pages that show a map, so the Google Maps script is not
// downloaded on every page. Vue.use() ignores repeated installs.
Vue.use(VueGeolocation)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD1kSW4Y1zf2SBhqIHE4JhvLWODN9ZkvuI',
    libraries: 'places'
  }
})
